import { RedlMetadataContext } from 'context/REDL/RedlMetadataProvider';
import { useContext } from 'react';
import __partial from 'lodash/partial';

export const useRedlMetadata = (pathname, routerQuery) => {
    const {
        setRedlPageMetadata,
        getRedlPageMetadata,
        isResetRedlPageMetadata,
        setIsResetRedlPageMetadata,
        getRedlBlocMetadata,
        setRedlPageRawLayout,
        getRedlPageRawLayout,
        getRedlBlocRawLayout,
        moveRedlBloc,
        addRedlBloc,
        editRedlBloc,
        deleteRedlBloc,
        setRedlNotRenderableInfo,
        resetRedlNotRenderableInfo,
        setRedlRenderableInfo,
        setIsPageRawLayoutShouldBeStored,
        removeRenderThumbnail,
        getZonaEditable
    } = useContext(RedlMetadataContext);

    const redlParamId = routerQuery?.['redl-id'];
    const redlParamTipologia = routerQuery?.['redl-tipologia'];

    return {
        setRedlPageMetadata: __partial(setRedlPageMetadata, pathname),
        getRedlPageMetadata: __partial(getRedlPageMetadata, pathname),
        isResetRedlPageMetadata: __partial(isResetRedlPageMetadata, pathname),
        setIsResetRedlPageMetadata: __partial(setIsResetRedlPageMetadata, pathname),
        getRedlBlocMetadata: __partial(getRedlBlocMetadata, pathname),
        setRedlPageRawLayout: __partial(setRedlPageRawLayout, pathname),
        getRedlPageRawLayout: __partial(getRedlPageRawLayout, pathname),
        getRedlBlocRawLayout: __partial(getRedlBlocRawLayout, pathname),
        moveRedlBloc: __partial(moveRedlBloc, pathname),
        addRedlBloc: __partial(addRedlBloc, pathname),
        editRedlBloc: __partial(editRedlBloc, pathname),
        deleteRedlBloc: __partial(deleteRedlBloc, pathname),
        setRedlNotRenderableInfo,
        resetRedlNotRenderableInfo,
        setIsPageRawLayoutShouldBeStored,
        removeRenderThumbnail: __partial(removeRenderThumbnail, pathname),
        setRedlRenderableInfo: __partial(setRedlRenderableInfo, pathname),
        getZonaEditable,
        redlParamId,
        redlParamTipologia
    };
};
